module.exports = __webpack_public_path__ + "img/3_45.c5c4ad79.png";